// extracted by mini-css-extract-plugin
module.exports = {"diamonds":"SellYourBags_diamonds__T8iM0","diamonds_images":"SellYourBags_diamonds_images__CXInE","button_container":"SellYourBags_button_container__hwTWb"};